import { AbstractControl, ValidationErrors } from '@angular/forms';

export function LatitudeValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value || (control.value <= 90 && control.value >= -90)) {
    return null;
  } else {
    return { customMessage: 'Latitude value must be between -90 and 90.' };
  }
}

export function LongitudeValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value || (control.value <= 180 && control.value >= -180)) {
    return null;
  } else {
    return { customMessage: 'Longitude value must be between -180 and 180' };
  }
}
